var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudButPlayerPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .playfill {\n        fill: #333;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "playfill",
    d: "M39.63,21.53L16.9,6.24c-2.77-1.86-6.49.12-6.49,3.45v30.59c0,3.33,3.72,5.31,6.49,3.45l22.72-15.29c2.45-1.65,2.45-5.26,0-6.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudButPlayerPlay);
export default __webpack_public_path__ + "static/media/cloud_but_player_play.2b3f8ba38309e74695a08fada96f5e72.svg";
export { ForwardRef as ReactComponent };